"use client";

import type { CandidateLanguage } from "@/lib/api/types";
import { titleCasePreserveAcronyms } from "@/lib/string/title-case";
import { SectionBody, SectionCard } from "../section-layout";
import { HighlightedText } from "@/features/arbitrator/components/review/highlighted-text";

export function LanguagesSection({ languages }: { languages: CandidateLanguage[] }) {
  if (languages.length === 0) return null;

  return (
    <SectionCard title="Languages">
      <SectionBody>
        <div className="flex w-full flex-col items-stretch gap-4 sm:flex-row sm:items-start">
          {languages.map((lang) => (
            <div
              key={lang.name}
              className="flex min-w-0 flex-1 flex-col items-start rounded-lg border border-border bg-surface-elevated p-3"
            >
              <p className="w-full min-w-0 break-words text-base font-medium leading-normal tracking-[-0.48px] text-foreground">
                <HighlightedText source="languages">{titleCasePreserveAcronyms(lang.name)}</HighlightedText>
              </p>
            </div>
          ))}
        </div>
      </SectionBody>
    </SectionCard>
  );
}
